interface ProgressBarProps {
  step: number;
  totalSteps: number;
  label: string;
}

const ProgressBar = ({ step, totalSteps, label }: ProgressBarProps) => {
  const percentage = (step / totalSteps) * 100;

  return (
    <div className="text-center mb-8">
      <p className="text-sm font-medium text-foreground mb-3">
        Etapa {step} de {totalSteps}: {label}
      </p>
      <div className="w-full max-w-md mx-auto h-2.5 rounded-full bg-muted overflow-hidden">
        <div
          className="h-full rounded-full bg-primary transition-all duration-500 ease-out"
          style={{ width: `${percentage}%` }}
        />
      </div>
    </div>
  );
};

export default ProgressBar;
